export default __webpack_public_path__ + "static/media/suite.fc11be92.jpg";